export default __webpack_public_path__ + "0dcdee84c2b8c4aaad1b4d40c69faea5.svg";